import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Chart from "react-google-charts";
import { BOX_SHADOWS, DATA_TYPES, SECONDARY_COLOR } from "../../constants";
import { stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { CustomHistogram } from "../Common/CustomHistogram";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
      position: "relative",
      height: "580px",
    },
  })
);

export function Histogram({ state }: stateType) {
  if (state.saveState.batchPrediction.batchData === undefined) {
    return <div></div>;
  }
  let col = state.saveState.dataset.getColumn(
    state.saveState.modelTraining.valueToPredict
  );
  if (col === undefined) {
    return <div></div>;
  }

  const isCat = col.columnType === DATA_TYPES.categorical;
  const dv = isCat ? 100 : 1;

  let data = [];
  let ndx = isCat ? 2 : 1;
  for (
    let i = 0;
    i < state.saveState.batchPrediction.batchData.data.length;
    i++
  ) {
    data.push([
      Number.parseFloat(
        state.saveState.batchPrediction.batchData.data[i][ndx]
      ) / dv,
    ]);
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        left: "2%",
        marginTop: "10px",
        height: "500px",
      }}
    >
      <Chart
        chartType="Histogram"
        loader={<div>Loading Chart</div>}
        data={[[state.saveState.modelTraining.valueToPredict], ...data]}
        style={{
          height: "500px",
          width: "98%",
          overflow: "hidden",
          position: "relative",
        }}
        options={{
          series: [{ color: SECONDARY_COLOR, dataOpacity: 0.7 }],
          chartArea: { width: "90%", height: "70%", top: 50 },
          hAxis: {
            title: isCat
              ? "Probabilities"
              : state.saveState.modelTraining.valueToPredict,
            slantedTextAngle: 90,
            slantedText: true,
            allowContainerBoundaryTextCutoff: true,
            format: isCat ? "percent" : undefined,
          },
          histogram: {
            hideBucketItems: true,
          },
          vAxis: { title: "Counts" },
          legend: { position: "none" },
        }}
        rootProps={{ "data-testid": "1" }}
      />
    </div>
  );
}

export function HistogramBox({ state }: stateType) {
  let classes = useStyles();
  let col = state.saveState.dataset.getColumn(
    state.saveState.modelTraining.valueToPredict
  );
  if (col === undefined) {
    return <div></div>;
  }
  if (
    state.saveState.batchPrediction.batchData === undefined ||
    state.saveState.batchPrediction.batchHistData === undefined
  ) {
    return <div></div>;
  }

  const isCat = col.columnType === DATA_TYPES.categorical;

  let data = [];
  let ndx = isCat ? 2 : 1;
  for (
    let i = 0;
    i < state.saveState.batchPrediction.batchData.data.length;
    i++
  ) {
    data.push(
      Number.parseFloat(state.saveState.batchPrediction.batchData.data[i][ndx])
    );
  }

  const title = isCat
    ? "Probability Distribution of Predictions"
    : "Predicted Values Distribution";

  const title2 = isCat
    ? `Predicted Probabilites for '${col.columnName}'`
    : `Predicted Values for '${col.columnName}'`;

  const tooltip = isCat
    ? "Shows the distribution of probabilities for the predicted class values."
    : "Shows the distribution of predictions of the predicted values.";

  return (
    <div className={classes.container}>
      <div style={{ width: "100%", marginBottom: "-10px" }}>
        <BoxHeader title={title} toolTip={tooltip} line={true}></BoxHeader>
      </div>
      <div
        style={{
          marginLeft: "-30px",
          width: "95%",
          marginTop: "50px",
        }}
      >
        <CustomHistogram
          state={state}
          title={title2}
          histData={state.saveState.batchPrediction.batchHistData}
          isCat={isCat}
        ></CustomHistogram>
      </div>
    </div>
  );
}
